<template>
  <AppDialog
    class="shift-overlap-dialog"
    data-testid="shift-overlap-dialog"
    title="Shift overlap"
    :show="show"
    append-to-body
    position="centered"
    @close="$emit('close')"
  >
    <div class="warning">
      <i class="hi-important icon"></i>
      <p>{{ mainMessage }}</p>
    </div>

    <div class="question">
      <p>{{ questionMessage }}</p>
    </div>

    <template #footer>
      <div class="actions">
        <div class="back-button">
          <AppButton
            data-testid="overlap-back-button"
            @click="$emit('close', 'back-to-previous-dialog')"
          >Back</AppButton>
        </div>
        <div>
          <AppButton
            type="danger"
            :disabled="saving"
            data-testid="overlap-remove-shift-button"
            @click="updateField({ field: 'remove_shifts', value: true })"
          >
            Remove {{ shiftText }}
          </AppButton>
          <AppButton
            type="primary"
            :disabled="saving"
            data-testid="overlap-keep-shift-button"
            @click="updateField({ field: 'remove_shifts', value: false })"
          >
            Keep {{ shiftText }}
          </AppButton>
        </div>
      </div>
    </template>
  </AppDialog>
</template>

<script>
export default {
  name: 'ShiftOverlapConfirmationDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    overlapShiftCount: {
      type: Number,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    shiftOverlapMessage: {
      type: String,
      default: '',
    },
    shiftOverlapQuestion: {
      type: String,
      default: '',
    },
    resource: {
      type: String,
      default: 'holiday',
    },
  },
  computed: {
    questionMessage() {
      return (
        this.shiftOverlapQuestion || `Do you want to keep the ${this.shiftText} and its notifications or remove them?`
      );
    },
    mainMessage() {
      return (
        this.shiftOverlapMessage || `This ${this.resource} overlaps with ${this.overlapShiftCount} ${this.shiftText}`
      );
    },
    shiftText() {
      return this.overlapShiftCount > 1 ? 'shifts' : 'shift';
    },
  },
  methods: {
    updateField({ field, value }) {
      this.$emit('update-remove-shift-field', field, value);
    },
  },
};
</script>
